<div class="graph-content">
  <app-form-field-date-range
    [fieldConfig]="dateRangeFieldConfig"
    [editMode]="true"
    [placeholder]="true"
    [formGroup]="form"
    [data]="form.value['date_range']"></app-form-field-date-range>
  <h3>{{ chartTitle }}</h3>
  @if (loading) {
    <div class="spinner-content">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  }
  <canvas [hidden]="loading" [id]="chartCode">{{ chart }}</canvas>
</div>
